import React from 'react'

import styles from './display-row.module.css'

export const DisplayRow = ({ title, text }) => (
  <div className={styles.row}>
    <div className={styles.title}>{title}:</div>
    <div className={`${styles.text} fs-mask`}>{text}</div>
  </div>
)
